var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mt-10" }, [
    _c(
      "div",
      { staticClass: "bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6" },
      [
        _c("div", { staticClass: "md:grid md:grid-cols-3 md:gap-6" }, [
          _vm._m(0),
          _c("div", { staticClass: "md:col-span-2" }, [
            _c("fieldset", { staticClass: "mt-6" }, [
              _c(
                "legend",
                {
                  staticClass: "text-base leading-6 font-medium text-gray-900"
                },
                [
                  _vm._v(
                    " Enable Chat & Share widget in your Online 2.0 theme "
                  )
                ]
              ),
              _c("div", { staticClass: "mt-4 flex flex-wrap" }, [
                _c(
                  "button",
                  {
                    staticClass:
                      "inline-flex items-center px-2.5 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
                    attrs: { type: "button" },
                    on: { click: _vm.openEmbedLink }
                  },
                  [_vm._v(" Open Theme Editor ")]
                )
              ])
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "md:col-span-1" }, [
      _c("h3", { staticClass: "text-lg font-medium leading-6 text-gray-900" }, [
        _vm._v(" Online Store 2.0 ")
      ]),
      _c("p", { staticClass: "mt-1 text-sm leading-5 text-gray-500" }, [
        _vm._v(
          " If your theme support App extensions you can use this option to enable/disable widgets. Please contact support before you enable . "
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }